import React, {
  Component
} from 'react';
import {
  Button,
  Grid,
  Header,
  Icon,
  Menu,
  Message,
  Modal,
  Loader,
  Segment
} from 'semantic-ui-react';
import {
  push
} from 'react-router-redux';
import {
  Link
} from 'react-router-dom';
import {
  Route
} from 'react-router-dom';
import {
  connect
} from 'react-redux';
import CoopEEconomicoDetalleView from './CoopEEconomicoDetalleView';
import AList from '../../auto/AList';
import AForm from '../../auto/AForm';

const PAGE_RANGE = 10;
const INITIAL_STATE = {
  upsertModal: {
    open: false
  },
  removeModal: {
    open: false,
    loading: false,
    id: null,
    error: null
  },
  eeconomicos: {
    loading: false,
    records: [],
    selected: null,
    error: null
  }
};

class CoopEconomicoView extends Component {

  constructor (props) {
    super(props);

    this.state = INITIAL_STATE;

    this.EEconomicoService = this.props.feathers.service('/api/eeconomicos');
  }

  componentDidMount () {
    this.fetchEEconomicos();
  }

  fetchEEconomicos (callback = () => {}) {
    this.setState({
      eeconomicos: {
        ...this.state.eeconomicos,
        loading: true,
        error: null
      }
    });

    this.EEconomicoService.find({
      query: {
        CooperativaId: this.props.cooperativa.id
      }
    })
      .then(response => {
        this.setState({
          eeconomicos: {
            ...this.state.eeconomicos,
            loading: false,
            records: response.records
          }
        }, callback);
      })
      .catch(error => {
        this.setState({
          eeconomicos: {
            ...this.state.eeconomicos,
            loading: false,
            error: error
          }
        });
      });
  }

  toggleUpdateEeconomicoModal (eeconomico = null) {
    this.setState({
      eeconomicos: {
        ...this.state.eeconomicos,
        selected: eeconomico
      },
      upsertModal: {
        ...this.state.upsertModal,
        open: !this.state.upsertModal.open
      }
    });
  }

  dismissUpsert () {
    this.setState({
      upsertModal: {
        ...this.state.upsertModal,
        open: false
      },
      eeconomicos: {
        ...this.state.eeconomicos,
        selected: null
      }
    });
  }

  doneSubmiting () {
    this.dismissUpsert();
    this.fetchEEconomicos(() => {
      let {
        eeconomicos
      } = this.state;
      if (eeconomicos.records.length !== 0) {
        console.log(eeconomicos.records);
        this.props.navigate('/cooperativa/2/eeconomicos/' + eeconomicos.records[0].id);
      }
    });
  }

  openRemoveModal (id) {
    this.setState({
      removeModal: {
        ...this.state.removeModal,
        open: true,
        id: id
      }
    });
  }

  dismissRemove () {
    this.setState({
      removeModal: INITIAL_STATE.removeModal
    });
  }

  removeRecord () {
    this.setState({
      removeModal: {
        ...this.state.removeModal,
        loading: true,
        open: true,
        error: null
      }
    });

    this.EEconomicoService.remove(this.state.removeModal.id)
      .then(response => {
        this.setState({
          removeModal: {
            ...this.state.removeModal,
            loading: false,
            open: false
          }
        }, () => {
          this.dismissRemove();
          this.props.navigate(`/cooperativa/${this.props.cooperativa.id}/eeconomicos`);
          this.fetchEEconomicos();
        });
      })
      .catch(error => {
        this.setState({
          removeModal: {
            ...this.state.removeModal,
            loading: false,
            error: error
          }
        });
      });
  }

  selectEeconomico (eeconomico, path) {
    this.setState({
      eeconomicos: {
        ...this.state.eeconomicos,
        selected: eeconomico
      }
    }, () => {
      this.props.navigate(path);
    });
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let {
      upsertModal,
      removeModal,
      eeconomicos
    } = this.state;
    let {
      cooperativa
    } = this.props;

    let cargoSelectConfig = {
      service: this.CargoService,
      mapFunction: (cargo, index) => {
        return {
          key: index,
          text: cargo.nombre,
          value: cargo.id
        };
      }
    };

    let personaSelectConfig = {
      service: this.PersonaService,
      mapFunction: (persona, index) => {
        return {
          key: index,
          text: `${persona.apellido}, ${persona.nombre} (${persona.dni})`,
          value: persona.id
        };
      }
    };

    return (
      <Grid>
        <Grid.Column width={3}>
          <Header as="h4">
            <Button
              as={Icon} basic compact icon="plus" primary disabled={eeconomicos.loading}
              onClick={this.toggleUpdateEeconomicoModal.bind(this)} />
            <Header.Content>
              Ejercicios Economicos
              <Header.Subheader>
                List de E. Economicos
              </Header.Subheader>
            </Header.Content>
          </Header>
          <Menu fluid vertical tabular>
            {
              eeconomicos.loading && <Loader active inline />
            }
            {
              eeconomicos.records.map((eeconomico, index) => {
                let active = !!window.location.pathname.match(new RegExp(`^/cooperativa/[0-9]*/eeconomicos/${eeconomico.id}/?$`));

                return (
                  <Menu.Item
                    key={index} active={active} onClick={this.selectEeconomico.bind(this, eeconomico, `/cooperativa/${cooperativa.id}/eeconomicos/${eeconomico.id}`)}>
                    {
                      active && <Icon name="trash" color="red" onClick={this.openRemoveModal.bind(this, eeconomico.id)} />
                    }
                    {
                      active ? <b>Nro. {eeconomico.nroEjercicio}</b> : `Nro. ${eeconomico.nroEjercicio}`
                    }
                    {
                      active &&
                        <Menu.Menu>
                          <Menu.Item
                            as={"button"} name="editar" onClick={this.toggleUpdateEeconomicoModal.bind(this, eeconomico)} />
                        </Menu.Menu>
                    }
                  </Menu.Item>
                );
              })
            }
          </Menu>
        </Grid.Column>

        <Grid.Column stretched width={13}>
          <Route exact path={`/cooperativa/:id/eeconomicos/:eeconomico`} render={({ match }) => {
            return (
              <CoopEEconomicoDetalleView match={match} />
            );
          }} />
        </Grid.Column>
        <Modal
          dimmer="blurring" size="small"
          open={upsertModal.open} onClose={this.dismissUpsert.bind(this)}>
          <Header icon="edit" content="Formulario de registro" />
          <Modal.Content>
            <AForm
              fields={[
                ['!Nro Ejercicio', 'nroEjercicio', 'input', 5],
                ['!Fecha Inicio', 'fechaInicio', 'date', 5],
                ['!Fecha Fin', 'fechaFin', 'date', 5]
              ]}
              record={eeconomicos.selected}
              service={this.EEconomicoService}
              options={{
                serviceParams: {
                  CooperativaId: this.props.cooperativa.id
                }
              }}
              dismiss={this.dismissUpsert.bind(this)}
              doneSubmiting={this.doneSubmiting.bind(this)} />
          </Modal.Content>
        </Modal>
        <Modal
          dimmer="blurring" basic size="small"
          open={removeModal.open} onClose={this.dismissRemove.bind(this)}>
          <Header icon="trash" content="Eliminar registro" />
          <Modal.Content>
            <p>Seguro desea eliminar este registro?</p>
            {
              removeModal.error &&
              <Message negative>
                <Message.Header>Error! {removeModal.error.message}</Message.Header>
                <p>
                  {removeModal.error.name}
                </p>
              </Message>
            }
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic color="red" inverted
              disabled={removeModal.loading} onClick={this.dismissRemove.bind(this)}>
              <Icon name="remove" /> No
            </Button>
            <Button color="green" inverted disabled={removeModal.loading} onClick={this.removeRecord.bind(this)}>
              <Icon name="checkmark" /> {removeModal.loading ? 'Procesando...' : 'Si'}
            </Button>
          </Modal.Actions>
        </Modal>
      </Grid>
    );
  }

}

export default connect(
  CoopEconomicoView.mapStateToProps,
  CoopEconomicoView.mapDispatchToProps
)(CoopEconomicoView);


// WEBPACK FOOTER //
// ./client/components/pages/cooperativas/CoopEconomicoView.js